export interface GroupSummary {
  id: string;
  name: string;
  privacy: GroupPrivacy;
}

export enum GroupPrivacy {
  Public = "Public",
  MembersOnly = "MembersOnly",
}

export interface CreateGroupInput {
  name: string;
  adminUserId: string;
  privacy: GroupPrivacy;
}

export enum GroupMemberRole {
  Member = "Member",
  Admin = "Admin",
}

export interface GroupMember {
  userId: string;
  groupId: string;
  role: GroupMemberRole;
}

export interface PendingGroupMember extends GroupMember {
  /** ISO date string */
  requestTimestamp: string;
}

export interface ActiveGroupMember extends GroupMember {
  /** ISO date string */
  memberSince: string;
}

export interface GroupMemberInput {
  userId: string;
  groupId: string;
}

export interface WithGroupId {
  groupId: string;
}

export interface WithMemberRole {
  role: GroupMemberRole;
}
